export default __webpack_public_path__ + "static/media/3.070e6fe5.jpg";